import { initializeApp } from '../app.js';
import OrderForm from '../components/OrderForm.vue';
import EuropamautOrderForm from '../components/Europamaut/EuropamautOrderForm.vue';

import jquery from 'jquery';
import 'bootstrap';
import 'bootstrap-datepicker';

import '../axios.js';
import '../echo.js';

window.$ = window.jQuery = jquery;

initializeApp('#app', {
    'order-form': OrderForm,
    'europamaut-order-form': EuropamautOrderForm,
});
